import {
    createClubContext, createCompetitionContext,
    createContentMetadataContext,
    createMatchContext, createPlayerContext,
    getDynamicArticleData, getDynamicClubData, getDynamicPlayerData
} from "./snowplowTracking";

export function getSnowplowVariables() {
    const { tracking = {} } = window?.forgeVariables || {};

    return {
        appId: tracking?.appId,
        collectorUrl: tracking?.collectorUrl,
        channelName: tracking?.channelName,
        category: tracking?.category,
        nameSpace: tracking?.nameSpace,
        pageType: tracking?.pageType,
        entityContexts: getEntityContextList(tracking?.entityContexts),
    }
}

function getEntityContextList(entityContexts) {
    return entityContexts?.split(',').filter(context => context !== "");
}


export function createPageContexts({
    mlsMatch,
    mlsTeam,
    mlsHomeTeam,
    mlsAwayTeam,
    mlsCompetition,
    mlsPlayer,
}) {
    const { entityContexts } = getSnowplowVariables();
    const contexts = [];

    entityContexts.forEach(entityContext => {
        if (entityContext === "match") {
            contexts.push(createMatchContext(mlsMatch));
        } else if (entityContext === "team") {
            if (mlsTeam) {
                contexts.push(createClubContext(mlsTeam));
            }
            if (mlsHomeTeam) {
                contexts.push(createClubContext(mlsHomeTeam));
            }
            if (mlsAwayTeam) {
                contexts.push(createClubContext(mlsAwayTeam));
            }
        }
        else if (entityContext === "competition") {
            contexts.push(createCompetitionContext(mlsCompetition));
        } else if (entityContext === "player") {
            contexts.push(createPlayerContext(mlsPlayer));
        }
    });

    return contexts;
}

/**
 * Returns the name of the schema.
 * @returns {string} - The name of the schema. player, club, article
 */
export function getSchemaName() {
    const { schema } = window?.forgeVariables?.tracking || {};

    return schema;
}

const schemaDataMapFunctions = {
    article: getDynamicArticleData,
    club: getDynamicClubData,
    player: getDynamicPlayerData,
}


/**
 * Returns the data for the dynamic schema.
 * @param {string} schemaName - The name of the schema. player, club, article
 * @returns {Object} - The data for the dynamic schema.
 */
export function getDynamicSchemaData(schemaName) {
    const schemaDataMapFunction = schemaDataMapFunctions[schemaName];

    if (!schemaDataMapFunction) {
        return undefined;
    }

    return schemaDataMapFunction();
}


/**
 * Returns a context object for the dynamic schema.
 * @returns {Object} - The context object for the dynamic schema.
 */
export function getDynamicSchemaContext() {
    const schemaName = getSchemaName();

    if (schemaName) {
        const schemaData = getDynamicSchemaData(schemaName);
        const createSchemaContextFunctions = {
            player: createPlayerContext,
            club: createClubContext,
            article: createContentMetadataContext,
        }
        const schemaContext = createSchemaContextFunctions[schemaName](schemaData);

        return schemaContext;
    }

    return null;
}



